import {createGrid} from "../../helpers/grids/grids";

function initGridsExamples() {
	createGrid(
		document.querySelector('.basic-grid'),
		{
			columnDefs: [
				{
					field: 'email',
					sortable: true,
				},
				{
					field: 'created_at',
					sortable: true,
				}
			],
		},
		window['routes/development.grids.examples/basic-grid'],
	)

	createGrid(
		document.querySelector('.basic-grid-no-pagination'),
		{
			columnDefs: [
				{
					field: 'email',
					sortable: true,
				},
				{
					field: 'created_at',
					sortable: true,
				}
			],
			pagination: false,
		},
		window['routes/development.grids.examples/basic-grid'],
	)
}

export {initGridsExamples}
